import { ISystemAsset, SUBTYPES } from "@dl/declarations";
import * as yup from "yup";

export type CreateAssetFormData = Pick<
  ISystemAsset,
  | "headline"
  | "image_caption"
  | "article_caption"
  | "credit"
  | "copyright"
  | "mime_type"
  | "type"
  | "subtypes"
  | "keywords"
  | "meta_data"
> & {
  _id?: string;
  file: File | null;
};

export interface UpdateAssetFormData extends CreateAssetFormData {
  src_url: string;
  created_at: string;
  updated_at: string;
}

export const initialValues: CreateAssetFormData = {
  file: null,
  type: "illustration",
  mime_type: "image",
  subtypes: [SUBTYPES.NEWS.ID],
  headline: "",
  meta_data: {
    description: "",
  },
  credit: "",
  copyright: "",
  keywords: [],
  image_caption: "",
  article_caption: "",
};

export const schema = yup
  .object()
  .shape({
    type: yup.string().required("Type is required"),
    mime_type: yup.string().required("MIME type is required"),
    subtypes: yup
      .array()
      .of(yup.string())
      .length(1, "Use exactly one category")
      // .min(1, "Use at least one category")
      .required("Categories are required"),
    headline: yup.string().required("Headline is required"),
    image_caption: yup.string().required("Image caption is required"),
    meta_data: yup.object({
      description: yup.string(),
    }),
    credit: yup.string().when("type", {
      is: "illustration",
      then: (schema) => schema.required("Credit is required for illustrations"),
      otherwise: (schema) => schema.optional(),
    }),
    copyright: yup.string().when("type", {
      is: "stock",
      then: (schema) =>
        schema.required("Copyright is required for illustrations"),
      otherwise: (schema) => schema.optional(),
    }),
    keywords: yup
      .array()
      .of(yup.string())
      .min(1, "Add at least one keyword")
      .required("Keywords are required"),
    article_caption: yup.string(),

    file: yup.mixed().nullable(),
    src_url: yup.string().url("Invalid URL").nullable(),
  })
  .test(
    "file-or-url",
    "Either a file or source URL is required",
    function (value) {
      const { file, src_url } = value;

      return !!(
        (file && file instanceof File) ||
        (src_url && typeof src_url === "string" && src_url.trim() !== "")
      );
    }
  );
